<div class="pos-steps-container steps-container">
  <div class="step-btns-container">
    <div class="btns-wrapper" appDragScroll>
      @for (step of steps; track step) {
        <button
          class="creation-step-btn btn btn-dark-theme cta-btn"
          (click)="setActiveStep(step)"
          [ngClass]="{ active: activeStep === step }"
          [disabled]="isStepDisabled(step)"
        >
          {{ stepLabel(step) | transloco }}
        </button>
      }
    </div>
  </div>

  <span class="icon-close cta-btn" [inlineSVG]="'/icons/icon-close.svg'" (click)="onClose()"></span>
  <div class="activate-container">
    @if (isActivateBtnsVisible) {
      <!-- The tooltip sits on a wrapper, not on the button: disabled buttons get pointer-events: none from
      the global .btn:disabled rule, so a tooltip on the button itself would be unreachable exactly when
      it has something to explain. -->
      @if (isActivateBtnVisible) {
        <span class="activate-btn-wrapper" [matTooltip]="activateTooltip | transloco" matTooltipClass="dig-tooltip">
          <button [disabled]="!canActivate" class="activate-btn btn cta-btn" (click)="onActivate()">
            {{ 'global.activate' | transloco }}
          </button>
        </span>
      }
      @if (isDeactivateBtnsVisible) {
        <button
          [matTooltip]="'pos_dashboard.pos_is_active' | transloco"
          matTooltipClass="dig-tooltip"
          class="deactivate-btn btn cta-btn"
          (click)="onDeactivate()"
        >
          {{ 'global.deactivate' | transloco }}
        </button>
      }
    }
  </div>
</div>
